export enum DAILY_GOAL_RESULT {
	RETURN_TO_DASHBOARD = 0,
	CONTINUE = 1,
}
